<template>
    <form-row title="Option Fee">
        <div class="sm:w-36 my-2">
            <div v-show="option_fee_by_percent">
                <input-money
                    :value="option_fee_by_percent"
                    tabindex="-1"
                    :read_only="true"
                />
            </div>

            <div v-show="! option_fee_by_percent">
                <input-money
                    v-model="option_fee_entered"
                    :read_only="read_only"
                />
            </div>

            <input
                name="option_fee_amount"
                type="hidden"
                :value="option_fee"
                :read_only="true"
            />
        </div>

        <div class="flex flex-1 items-center my-2">
            <span class="text-sm text-gray-600 sm:pl-6 pr-6">
                {{ $t('- OR -') }}
            </span>

            <div class="w-1/4 sm:w-1/5">
                <input-percent
                    name="option_fee_percent"
                    v-model="option_fee_percent"
                    :read_only="read_only"
                />
            </div>

            <span class="text-sm text-gray-600 leading-snug pl-4">
                {{ $t('of') }} {{ purchase_price_formatted }} <br>{{ $t('purchase price') }}
            </span>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            option_fee_percent: this.commercial.option_fee_percent,
            option_fee_entered: this.commercial.option_fee_amount,
        }
    },

    computed: {
        purchase_price() {
            return this.formatMoney(store.state.purchase_price);
        },
        option_fee_by_percent() {
            return this.option_fee_percent
                ? this.formatMoney((this.option_fee_percent / 100) * this.moneyVal(this.purchase_price))
                : null;
        },
        option_fee() {
            return this.option_fee_by_percent || this.option_fee_entered;
        },
        purchase_price_formatted() {
            return this.purchase_price && ! isNaN(this.purchase_price)
                ? '$' + this.formatMoneyToString(this.purchase_price)
                : '';
        },
    },

    watch: {
        option_fee(val, oldVal) {
            this.$emit('change', val);
        },
    },
}
</script>
